import { useState, useEffect, Fragment } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Outlet, useNavigate } from "react-router-dom";
import Image from "./login_background.webp";
import Logo from "../../logo.webp";
import {
  Box,
  Card,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  CardActions,
  CardContent,
  Button,
  Typography,
  TextField,
  Backdrop,
  CircularProgress,
  List,
  ListItem,
  ListItemText,
  Grid
} from "@mui/material";

import { http, utils as u } from "../../lib/index.js";
import { login } from "../../redux/reducers/authSlice";
import { useLoginMutation } from "../../redux/api/authApiSlice";
import {
  useCreateTokenMutation,
  useChangePasswordMutation,
} from "../../redux/reducers/resetPasswordSlice";
import {
  setCredentials,
  selectCurrentUser,
} from "../../redux/reducers/authSlice";
import { FormContainer, TextFieldElement } from "react-hook-form-mui";
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import IconButton from "@mui/material/IconButton";
import theme from '../../theme';
const LoginForm = (props) => {
  const [
    initLogin,
    {
      data: loginRes,
      isLoading: signing,
      error: signingError,
      isSuccess,
      isError,
    },
  ] = useLoginMutation();

  const [formData, setFormData] = useState({ email: "", password: "" });
  const [showChangePasswordForm, setShowChangePassowordForm] = useState(false); //A: estado para mostrar el form de cambio de password (primer login del usuario)
  const [ErrMsg, setErrMsg] = useState(null);
  const [showPassword, setShowPassword] = useState(false)
  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });
  const currentUser = useSelector(selectCurrentUser);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const submit = async () => {
    formData.email = formData.email.trimStart().trimEnd()
    formData.password = formData.password.trimStart().trimEnd()
    try {
      const loginRes = await initLogin(formData).unwrap();
      dispatch(
        setCredentials({
          accessToken: loginRes.jwt,
          user: {
            ...loginRes.persona,
            roles: loginRes.roles,
            permisos: loginRes.permisos,
          },
        })
      );
      setFormData({ email: "", password: "" });
        if (loginRes?.roles) {
          if (loginRes?.roles?.find(r => r === "Ahorrista")) {
            navigate("/dashboard/miscontratos")
          } else {
            navigate("/dashboard/contratos");
          }
      }

    } catch (err) {
      console.error(err);
      if (!err?.status) {
        // isLoading: true until timeout occurs
        setErrMsg("No Server Response.");
      } else if (err.status === 400) {
        setErrMsg("Missing Username or Password.");
      } else if (err.status === 401) {
        console.error(err);
        setErrMsg("Usuario o Contraseña incorrecta.");
      } else if (err.status === 403) {
        setShowChangePassowordForm(true);
      } else {
        setErrMsg("Login Failed.");
      }
    }
  };

  const ChangePasswordForm = () => {
    const [initChangePassword] = useChangePasswordMutation();
    const [changeWasSuccess, setChangeWasSuccess] = useState(false);
    const [showPassword1, setShowPassword1] = useState(false)
    const [showPassword2, setShowPassword2] = useState(false)
    const [ msg,setMsg] = useState('')
    const changePasswordSubmit = async (data) => {
      setMsg('')
      if (data.newPassword !== data.reNewPassword){ setMsg('Las nuevas contraseñas no son iguales.'); return}
      data.email = formData.email.trimStart().trimEnd()
      data.password = data.password.trimStart().trimEnd()
      data.newPassword = data.newPassword.trimStart().trimEnd()
      data.reNewPassword = data.reNewPassword.trimStart().trimEnd()
      initChangePassword(data)
      .unwrap()
      .then((res) => {
        console.log(res);
        setChangeWasSuccess("OK");
        setMsg('Contraseña actualizada. Redireccionando...')
        setTimeout(() => {
          formData.password = //formData.password.trimStart().trimEnd()
          setShowChangePassowordForm(false)
      }, 3000);
      })
      .catch((err) => {
        console.error(err);
        setChangeWasSuccess(false);
      });
      return
    };

    return (
      <Fragment>
        <Box sx={{ minWidth: 275, width: 450, padding: 20 }}>
          <Card variant="outlined">
            <FormContainer
              defaultValues={{
                password: "",
                newPassword: "",
                reNewPassword: "",
              }}
              onSuccess={changePasswordSubmit}
            >
              <CardContent
                sx={{ display: "grid", padding: 5, paddingBottom: 0 }}
              >
                <Typography
                  sx={{
                    fontSize: 18,
                    fontWeight: 600,
                    color: "#868686",
                    marginBottom: 3,
                  }}
                  color="text.primary"
                  gutterBottom
                >
                  Debe cambiar su contraseña por primera vez.
                </Typography>

                <TextFieldElement
                  sx={{ marginBottom: "10px" }}
                  label="Contraseña"
                  name="password"
                  type="password"
                  required
                />
                <Grid conteiner direction='row' spacing={1} xs={{
                  display: "inline-flex",
                  justifyContent: "space-between",
                  alignItems: "strech", alingContent: "center"
                }}>
                  <TextFieldElement
                    sx={{ marginBottom: "10px", width: "85%" }}
                    label="Nueva Contraseña"
                    name="newPassword"
                    type={showPassword1 ? 'text' : "password"}
                    required
                  />
                  <IconButton sx={{ width: "10%", marginTop: "6px", marginLeft: "6px" }} onClick={() => setShowPassword1(!showPassword1)}> {showPassword1 ? <VisibilityOutlinedIcon color='secondary' /> : <VisibilityOffOutlinedIcon color='secondary' />} </IconButton>
                </Grid>
                <Grid conteiner direction='row' spacing={1} xs={{
                  display: "inline-flex",
                  justifyContent: "space-between",
                  alignItems: "strech", alingContent: "center"
                }}>
                  <TextFieldElement
                    sx={{ width: "85%" }}
                    label="Re ingrese nueva Contraseña"
                    name="reNewPassword"
                    type={showPassword2 ? 'text' : "password"}
                    required
                  />
                  <IconButton sx={{ width: "10%", marginTop: "6px", marginLeft: "6px" }} onClick={() => setShowPassword2(!showPassword2)}> {showPassword2 ? <VisibilityOutlinedIcon color='secondary' /> : <VisibilityOffOutlinedIcon color='secondary' />} </IconButton>
                </Grid>
                <Typography
                  sx={{
                    fontSize: 18,
                    fontWeight: 600,
                    color: "#868686",
                    marginTop: 3,
                  }}
                  color="text.primary"
                >
                  {msg}
                </Typography>
              </CardContent>
              <CardActions>
                <Button
                  type="submit"
                  variant="contained"
                  sx={{ padding: 1, marginLeft: 4, fontWeight: 'bold' }}
                  size="small"
                >
                  ENVIAR
                </Button>
                <Button
                  variant="outlined"
                  sx={{ padding: 1, margin: 3, fontWeight: 'bold' }}
                  size="small"
                  onClick={() => setShowChangePassowordForm(false)}
                >
                  Volver a Login
                </Button>
              </CardActions>
            </FormContainer>
          </Card>
        </Box>
        {/* <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={resetPasswordLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop> */}
      </Fragment >
    );
  };

  return (
    <Fragment>
      {showChangePasswordForm ? (
        <ChangePasswordForm />
      ) : (
        <Fragment>
          <Box sx={{ minWidth: 275, width: 400, padding: 20 }}>
            <Card variant="outlined">
              <Fragment>
                <FormContainer handleSubmit={submit}>
                  <CardContent
                    sx={{ display: "grid", padding: 5, paddingBottom: 0 }}
                  >
                    <Typography
                      sx={{
                        fontSize: 18,
                        fontWeight: 600,
                        color: "#868686",
                        marginBottom: 3,
                      }}
                      color="text.primary"
                      gutterBottom
                    >
                      Ingresar con usuario y contraseña
                    </Typography>
                    <TextField
                      id="email"
                      type="email"
                      name="email"
                      label="Email"
                      variant="standard"
                      value={formData.email}
                      onChange={handleChange}
                      autoComplete="on"
                      required
                    />
                    <Grid conteiner direction='row' spacing={1} xs={{
                      display: "inline-flex",
                      justifyContent: "space-between",
                      alignItems: "strech", alingContent: "center"
                    }}>
                      <TextField
                        sx={{ width: "90%" }}
                        id="passward"
                        type={showPassword ? 'text' : "password"}
                        name="password"
                        label="Contraseña"
                        variant="standard"
                        value={formData.password}
                        onChange={handleChange}
                        autoComplete="on"
                        required
                      />
                      <IconButton sx={{ width: "10%", marginTop: "8px" }} onClick={() => setShowPassword(!showPassword)}> {showPassword ? <VisibilityOutlinedIcon color='secondary' /> : <VisibilityOffOutlinedIcon color='secondary' />} </IconButton>
                    </Grid>
                    <Button
                      sx={{ marginTop: 2, fontWeight: "bold" }}
                      variant="text"
                      onClick={() => props.setShowResetPassowordForm(true)}
                    >
                      Olvide mi Contraseña
                    </Button>
                  </CardContent>
                  <CardActions>
                    <Button
                      variant="contained"
                      sx={{ padding: 1, margin: 3, fontWeight: "bold" }}
                      size="small"
                      type="submit"
                      onClick={submit}
                    >
                      INGRESAR
                    </Button>
                  </CardActions>
                </FormContainer>
              </Fragment>
            </Card>
          </Box>
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={signing}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
          <Dialog
            open={ErrMsg}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle  fontWeight={700} style={{ backgroundColor: theme.palette.success.main, color: 'white' }} id="alert-dialog-title">
              Error al iniciar sesión:{" "}
            </DialogTitle>
            <DialogContent dividers>
              <DialogContentText id="alert-dialog-description">
                {ErrMsg}
              </DialogContentText>
            </DialogContent>
            <DialogActions >
              <Button onClick={() => setErrMsg(null)} autoFocus>
                VOLVER
              </Button>
            </DialogActions>
          </Dialog>
        </Fragment>
      )}
    </Fragment>
  );
};

const ResetPasswordForm = (props) => {
  const [
    initResetPassword,
    {
      data: resetPasswordRes,
      isLoading: resetPasswordLoading,
      error: resetPasswordLoadingError,
      isSuccess,
      isError,
    },
  ] = useCreateTokenMutation();

  const [formData, setFormData] = useState({ email: "" });
  const [message, setMessage] = useState(null);
  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const volver = () => props.setShowResetPassowordForm(false);

  const submit = async () => {
    try {
      const resetPasswordRes = await initResetPassword([
        formData.email.trimStart().trimEnd(),
      ]).unwrap(); //A: el endpoint recibe un array de emails
      resetPasswordRes === false ? setMessage('No existe un usuario con el mail ' + formData.email) :
        setMessage(`Se ha enviado un email a su casilla con las instrucciones a la casilla ${formData.email} para restablecer su contraseña.`);
      setFormData({ email: "" });
    } catch (err) {
      console.error(err);
      setMessage("Error al enviar el email");
    }
  };

  return (
    <Fragment>
      <Box sx={{ minWidth: 275, width: 400, padding: 20 }}>
        <Card variant="outlined">
          <Fragment>
            <CardContent sx={{ display: "grid", padding: 5, paddingBottom: 0 }}>
              <Typography
                sx={{
                  fontSize: 18,
                  fontWeight: 600,
                  color: "#868686",
                  marginBottom: 3,
                }}
                color="text.primary"
                gutterBottom
              >
                Ingrese su Email.
              </Typography>

              <TextField
                id="outlined-basic"
                name="email"
                label="Email"
                variant="standard"
                value={formData.email}
                onChange={handleChange}
              />

              {message && (
                <Typography
                  sx={{
                    fontSize: 14,
                    fontWeight: 300,
                    color: "#868686",
                    marginBottom: 3,
                    marginTop: 1,
                  }}
                  color="text.primary"
                  gutterBottom
                >
                  {" "}
                  {message}{" "}
                </Typography>
              )}
            </CardContent>
            <CardActions sx={{ padding: 1, margin: 3 }}>
              <Button variant="contained" sx={{ fontWeight: "bold" }} size="small" onClick={submit}>
                Enviar
              </Button>
              <Button variant="outlined" sx={{ fontWeight: "bold" }} size="small" onClick={volver}>
                Volver
              </Button>
            </CardActions>
          </Fragment>
        </Card>
      </Box>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={resetPasswordLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </Fragment>
  );
};

const LoginPage = () => {
  const [showResetPassowordForm, setShowResetPassowordForm] = useState(false); //A: estado para mostrar el form de reset password (se olvido su contraseña)

  return (
    <Fragment>
      <img
        src={Logo}
        alt="Logo"
        style={{ position: "absolute", margin: "25px" }}
        width={"151.05px"}
        height={"55.425px"}
      />
      <div
        style={{
          backgroundImage: `url(${Image})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          height: "100vh",
          display: "flex",
          justifyContent: "center",
        }}
      >
        {showResetPassowordForm ? (
          <ResetPasswordForm
            setShowResetPassowordForm={setShowResetPassowordForm}
          ></ResetPasswordForm>
        ) : (
          <LoginForm
            setShowResetPassowordForm={setShowResetPassowordForm}
          ></LoginForm>
        )}
      </div>
    </Fragment>

    //<img src={Image} />
  );
};

export default LoginPage;